module.exports = __webpack_public_path__ + "img/6c.26b03794.png";